import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "../../../Translation";
import { Cog8ToothIcon, DocumentIcon, DocumentPlusIcon, ExclamationCircleIcon, MinusIcon, PlusIcon } from "@heroicons/react/24/outline";
import { TextInput } from "../../Inputs/TextInput";
import { TextArea } from "../../Inputs/TextArea";
import { Button } from "../../Buttons";
import Tabs, { useTabs } from "../../Tabs";
import { useAPI } from "../../../API";
import { bgColor, hoverBgColor, textColor } from "../../../Resources/CSS/styling";


const ConfigurationTab = ({ tmpStep, setTmpStep, save, error, isCreate }) => {

    const { translate } = useTranslation();
    const api = useAPI();
    const [dataError, setDataError] = useState(null);
    const [event_data, setEventData] = useState(Object.keys(tmpStep.data.event_data).filter(key => key !== 'contact_external_id').map(key => ({
        key: key,
        value: tmpStep.data.event_data[key]
    })));

    useEffect(() => {
        setTmpStep({ ...tmpStep, data: { ...tmpStep.data, event_data: event_data.reduce((acc, curr) => {
            acc[curr.key] = curr.value;
            return acc;
        }, {}) } });

        console.log(event_data);
        console.log(tmpStep.data.event_data);

        if (hasDuplicateKeys(event_data)) {
            setDataError(translate('automatisation.track_event_data_duplicate_keys'));
        } else {
            setDataError(null);
        }

    }, [event_data]);

    useEffect(() => {
        if (!tmpStep.data.contact_external_id && Object.keys(tmpStep.data.event_data).some(key => key === 'contact_external_id')) {
            setTmpStep({ ...tmpStep, data: { ...tmpStep.data, contact_external_id: tmpStep.data.event_data.contact_external_id } });
        }
    }, [tmpStep]);

    const addHeader = () => {
        var keyIndex = 0;
        while (event_data.some(header => header.key === `key_${keyIndex}`)) {
            keyIndex++;
        }

        setEventData([...event_data, { key: `key_${keyIndex}`, value: 'value' }]);
    }

    const removeHeader = (data_object_in_array) => {
        setEventData(event_data.filter(d => d !== data_object_in_array));
    }

    // const event_data = useMemo(() => Object.keys(tmpStep.data.event_data).map(key => ({
    //     key: key,
    //     value: tmpStep.data.event_data[key]
    // })), [tmpStep]);

    const hasDuplicateKeys = (data) => {
        const seenKeys = new Set();
        for (const item of data) {
            if (seenKeys.has(item.key)) {
                return true; // Found a duplicate
            }
            seenKeys.add(item.key);
        }
        return false;
    };

    const updateHeader = (data_object_in_array, updateKey, value) => {

        if (updateKey) {
            setEventData(event_data.map(d => data_object_in_array === d ? {...d, key: value} : d));
        } else {
            setEventData(event_data.map(d => data_object_in_array === d ? {...d, value: value} : d));
        }
    }
  
    return (
        <div className="flex flex-col mt-4 overflow-visible">

            {error && <p className="text-red-600 flex flex-row items-center bg-red-50 p-4"><ExclamationCircleIcon className="w-6 h-6 mr-2" />{error}</p>}
            {dataError && <p className="text-red-600 flex flex-row items-center bg-red-50 p-4"><ExclamationCircleIcon className="w-6 h-6 mr-2" />{dataError}</p>}

            <p className="text-xl text-gray-600 font-bold mt-2">{translate('automatisation.track_event_name')}</p>
            <TextInput value={tmpStep.data.event_name} onChange={(e) => setTmpStep({ ...tmpStep, data: { ...tmpStep.data, event_name: e.target.value } })} />

            <p className="text-xl text-gray-600 font-bold mt-2">{translate('automatisation.track_event_contact_external_id')}</p>
            <TextInput value={tmpStep.data.contact_external_id} onChange={(e) => setTmpStep({ ...tmpStep, data: { ...tmpStep.data, contact_external_id: e.target.value } })} />

            <div className="flex flex-row mt-2 items-center justify-between">
                <p className="text-xl text-gray-600 font-bold mt-2">{translate('automatisation.track_event_data')}</p>
                <PlusIcon onClick={addHeader} className="w-6 h-6 text-gray-600 cursor-pointer hover:text-gray-300" />
            </div>

            {event_data.map((in_data, index) => (
                <div className="flex flex-row w-full flex-1 items-center">
                    <div className="flex w-32">
                        <TextInput value={in_data.key} onChange={(e) => {
                            updateHeader(in_data, true, e.target.value);
                        }} />
                    </div>
                    <div className="flex flex-1 w-full flex-col ml-2">
                        <TextInput value={in_data.value} onChange={(e) => {
                            updateHeader(in_data, false, e.target.value);
                        }} />
                    </div>
                    <MinusIcon onClick={() => removeHeader(in_data)} className="w-6 h-6 text-red-600 cursor-pointer ml-2 hover:text-red-300" />
                </div>
            ))}

            {!isCreate && <div className="flex flex-row w-full flex-1 justify-end mt-4">
                <div className="flex flex-row">
                    <Button disabled={dataError} className="bg-black hover:bg-gray-800" onClick={() => save(tmpStep)}>
                        {translate('save')}
                    </Button>
                </div>
            </div>}
        </div>
    )
}

const DescriptionTab = ({ tmpStep, setTmpStep, save, isCreate }) => {
    const { translate } = useTranslation();
    return (
        <div className="flex flex-col mt-4">
            <p className="text-xl text-gray-600 font-bold">{translate('automatisation.description')}</p>
            <TextArea rows={5} value={tmpStep.description} onChange={(e) => setTmpStep({ ...tmpStep, description: e.target.value })} />

            {!isCreate && <div className="flex flex-row w-full flex-1 justify-end mt-4">
                <div className="flex flex-row">
                    <Button className="bg-black hover:bg-gray-800" onClick={() => save(tmpStep, JSON.stringify(tmpStep.data.body))}>
                        {translate('save')}
                    </Button>
                </div>
            </div>}
        </div>
    )
}

export default function TrackPanel({ setStepToClone, panelHook, step, refresh, deleteStep, isCreate, onCreateNewStep }) {
    const { translate } = useTranslation();
    const [isExpanded, setIsExpanded] = useState(false);
    const [tmpStep, setTmpStep] = useState({ ...step });
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const api = useAPI();

    const tabs = useTabs([
        { icon: Cog8ToothIcon, name: translate('automatisation.configuration'), current: true },
        { icon: DocumentIcon, name: translate('automatisation.description'), current: false }
    ]);
    
    // Reset tmpStep when panel is closed
    useEffect(() => {
        if (!panelHook.open) {
            setTmpStep({ ...step });
        }
    }, [panelHook.open]);

    const save = async (tmpStep) => {


        try {

            if (tmpStep.data.contact_external_id) { 
                tmpStep.data.event_data = {
                    ...tmpStep.data.event_data,
                    contact_external_id: tmpStep.data.contact_external_id
                }
            }

            if (isCreate) {
                if (!tmpStep.description || tmpStep.description.trim() === '') {
                    tmpStep.description = "Track event " + tmpStep.data.event_name;
                }

                const newStepResponse = await api.createAutomatisationStep(tmpStep.automatisation_id, tmpStep);
                if (newStepResponse.data.automatisation_step) {
                    onCreateNewStep(newStepResponse.data.automatisation_step);
                }
            } else {
                await api.updateAutomatisationStep(tmpStep.automatisation_id, tmpStep);
            }

            panelHook.setOpen(false);
            setTimeout(() => {
                refresh();
            }, 1000);
        } catch (e) {
            setError('Invalid JSON');
            return;
        }

    }

    const selectStepToClone = (step) => {
        setStepToClone(step);
        panelHook.setOpen(false);
    }


    return (
        <div className="flex flex-col flex-1 rounded-md p-4 overflow-hidden h-full w-96">
            <div className="flex flex-row items-center">
                <DocumentPlusIcon className={`w-12 h-12 min-w-12 min-h-12 aspect-square border p-2 bg-gray-50 rounded-md mr-2 ${textColor}`} />
                <div className="flex flex-col ml-2">
                    <h2 className="text-xl font-bold">{translate('automatisation.track')}</h2>
                </div>
                
                <div className="flex flex-row flex-1 justify-end">

                {!isCreate && <Button className="bg-red-600 hover:bg-red-300 ml-4" onClick={deleteStep}>
                        {translate('delete')}
                    </Button>}
                {isCreate && <Button className={`${bgColor} ${hoverBgColor} ml-4 opacity-100`} onClick={() => save(tmpStep)}>{translate('create')}</Button>}
                {!isCreate && <Button className={`${bgColor} ${hoverBgColor} ml-4 opacity-100`} onClick={() => selectStepToClone(tmpStep)}>{translate('clone')}</Button>}
                </div>
            </div>

            <div className="flex flex-row overflow-x-scroll no-scrollbar">
                <Tabs tabs={tabs} />
            </div>

            {tabs.currentTabIndex === 0 && <ConfigurationTab tmpStep={tmpStep} setTmpStep={setTmpStep} panelHook={panelHook} error={error} save={save} isCreate={isCreate} />}
            {tabs.currentTabIndex === 1 && <DescriptionTab tmpStep={tmpStep} setTmpStep={setTmpStep} panelHook={panelHook} error={error} save={save} isCreate={isCreate} />}
        </div>
    )
}